import _axios from '@/plugins/axios'

export function getAuthLoginAddress(url) {
  return _axios({
    url: `/wx/oauth2/get?url=${url}`,
    method: 'get'
  })
}

export function login(code) {
  return _axios({
    url: `/wx/oauth2/callback?code=${code}`,
    method: 'post'
  })
}
